import React from "react";

function RequirementCpd() {
  return <div></div>;
}

export default RequirementCpd;
